export const USER_ROLES = {
    HANGFIRE_ADMIN: "HangfireAdmin",
    SPECTERR_ADMIN: "SpecterrAdmin",
    PRESETS_CREATOR: "PresetsCreator"
}